module.exports = __webpack_public_path__ + "static/img/5.72f088c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/5.png
// module id = mUBp
// module chunks = 0